<div class="main-container">
    <div *ngIf="isLoading" class="spinner-container">
        <mat-spinner [diameter]="50"></mat-spinner>
    </div>
    <div class="heading-container">
        <div class="left-section">
            <div class="icon-container" (click)="goBack()">
                <mat-icon svgIcon="arrowleft" class="back-icon"></mat-icon>
            </div>

            <div class="title-container">
                <p class="title font-poppins">{{ action }} Items</p>
                <p class="subtitle">{{ heading }}</p>
            </div>
        </div>
    </div>

    <div class="bottom-section">
        <form [formGroup]="returnExchangeForm" class="bottom-left">
            @for(item of orderItems; let i = $index; track i ){
            <div class="product-section">
                <div class="detail-pro">
                    <img
                        class="product-image"
                        [class]="'product-image-gradient' + ((i % 3) + 1)"
                        [src]="item.product?.images?.imagesUrl?.[0]"
                    />
                    <div class="product-right-section">
                        <h3 class="font-poppins product-name" appEllipsis maxWidth="80%">{{ item?.product?.name }}</h3>
                        <p *ngIf="item.product?.modelQuantityJson" class="block">
                            {{ item.product?.modelQuantityJson?.totalBlock }} Blocks
                        </p>
                        <h2 class="price font-poppins">
                            ₹
                            {{
                                item.product?.discountedPrice
                                    ? (item.product?.discountedPrice | number: "1.0-0")
                                    : (item.product?.price | number: "1.0-0")
                            }}
                        </h2>
                    </div>
                </div>
            </div>
            <div class="reason-section" *ngIf="(isCod && action === 'return') || 'exchange'">
                <h3 class="font-poppins title" for="reason">{{ label }}</h3>
                <label>This helps us improve our service</label>
                <span>{{ action }} Reason</span>
                <mat-form-field appearance="outline" class="custom-form-field">
                    <textarea
                        matInput
                        maxlength="50"
                        [id]="'reason-' + i"
                        [formControl]="getReasonControl(i)"
                        placeholder="Write a short reason for your return..."
                    ></textarea>
                </mat-form-field>
                <p>Help us understand your experience</p>
            </div>
            } @if( action === 'return' && isCod){
            <div class="transaction-section">
                <h3 class="font-poppins">Choose Refund Method</h3>
                <p for="reason">{{ "returnReplaceCancel.selectOtion" | translate }}</p>
                <div class="mode-refund">
                    <mat-radio-group formControlName="refundOption" class="radio-group">
                        <div
                            class="radio-btn"
                            [class.selected]="returnExchangeForm.get('refundOption')?.value === 'bankDetails'"
                        >
                            <div class="bank-section">
                                <div class="icon">
                                    <mat-icon svgIcon="bank"></mat-icon>
                                </div>
                                <mat-radio-button value="bankDetails"></mat-radio-button>
                            </div>

                            <section>
                                <h4 class="font-poppins">Bank Transfer</h4>
                                <p>3-5 business days</p>
                            </section>
                        </div>
                        <div
                            class="radio-btn"
                            [class.selected]="returnExchangeForm.get('refundOption')?.value === 'upi'"
                        >
                            <div class="bank-section">
                                <div class="icon">
                                    <mat-icon svgIcon="mobilePhone"></mat-icon>
                                </div>
                                <mat-radio-button value="upi"></mat-radio-button>
                            </div>

                            <section>
                                <h4 class="font-poppins">UPI</h4>
                                <p>Instant transfer</p>
                            </section>
                        </div>
                    </mat-radio-group>
                </div>

                <div
                    *ngIf="returnExchangeForm.get('refundOption')?.value === 'bankDetails'"
                    formGroupName="bankDetails"
                    class="bank-detail-section"
                >
                    <h4 class="font-poppins">Bank Account Details</h4>

                    <mat-form-field appearance="outline" class="custom-form-field">
                        <input
                            matInput
                            formControlName="accountHolderName"
                            placeholder="Account Holder Name"
                            type="text"
                        />
                        @if ( returnExchangeForm.get('bankDetails.accountHolderName')?.touched &&
                        returnExchangeForm.get('bankDetails.accountHolderName')?.invalid ) {
                        <mat-error>
                            @if (returnExchangeForm.get('bankDetails.accountHolderName')?.hasError('required')) {
                            {{ "genericDialogBox.label.accountHolderName" | translate }}
                            {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                            } @else if
                            (returnExchangeForm.get('bankDetails.accountHolderName')?.hasError('invalidAccountHolderName'))
                            {
                            {{ "genericDialogBox.invalidMessage.accountNameInvalid" | translate }}
                            }
                        </mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="custom-form-field">
                        <input matInput formControlName="accountNumber" placeholder="Bank Account Number" />
                        @if ( returnExchangeForm.get('bankDetails.accountNumber')?.touched &&
                        returnExchangeForm.get('bankDetails.accountNumber')?.invalid ) {
                        <mat-error>
                            @if (returnExchangeForm.get('bankDetails.accountNumber')?.hasError('required')) {
                            {{ "genericDialogBox.label.accountNo" | translate }}
                            {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                            } @else if
                            (returnExchangeForm.get('bankDetails.accountNumber')?.hasError('invalidAccountNumber')) {
                            {{ "genericDialogBox.invalidMessage.accountnoInvalid" | translate }}
                            }
                        </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="custom-form-field">
                        <input matInput formControlName="ifscCode" placeholder="IFSC Code" type="text" />
                        @if ( returnExchangeForm.get('bankDetails.ifscCode')?.touched &&
                        returnExchangeForm.get('bankDetails.ifscCode')?.invalid ) {
                        <mat-error>
                            @if (returnExchangeForm.get('bankDetails.ifscCode')?.hasError('required')) {
                            {{ "genericDialogBox.label.ifscCode" | translate }}
                            {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                            } @else if (returnExchangeForm.get('bankDetails.ifscCode')?.hasError('invalidIfsc')) {
                            {{ "genericDialogBox.invalidMessage.ifscInvalid" | translate }}
                            }
                        </mat-error>
                        }
                    </mat-form-field>

                    <label
                        ><mat-icon svgIcon="safematerial"></mat-icon> Your banking information is encrypted and secure.
                        We never store your full account details.</label
                    >
                </div>

                <div
                    class="bank-detail-section"
                    *ngIf="returnExchangeForm.get('refundOption')?.value === 'upi'"
                    formGroupName="upi"
                >
                    <h4 class="font-poppins">Enter your UPI ID</h4>
                    <mat-form-field appearance="outline" class="custom-form-field">
                        <input matInput formControlName="upiId" placeholder="e.g.tom@oksbi" type="email" />
                        @if(returnExchangeForm.get('upi.upiId')?.hasError('invalidUPI')){
                        <mat-error>{{ "genericDialogBox.invalidMessage.upiIdInvalid" | translate }}</mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
            }
        </form>
        <div class="bottom-right">
            <h4 class="font-poppins">{{ action }} Summary</h4>
            <div class="bottom">
                <div class="price-summary">
                    <p>Product Price</p>
                    <p class="total-amount">₹ {{ totalAmount }}</p>
                    <label>{{ action }} Processing</label>
                    <span>FREE</span>
                    <p>Shipping</p>
                    <span>Free Pickup</span>
                    <div class="divider"></div>
                    <h4 class="font-poppins">Total {{ action }}</h4>
                    <h2 class="total font-poppins">₹ {{ totalAmount | number: "1.0-0" }}</h2>
                </div>

                <div class="time-content">
                    <div class="process">
                        <div class="icon">
                            <mat-icon svgIcon="clock"></mat-icon>
                        </div>
                        <div class="text">
                            <label>Processing Time</label>
                            <p>3-5 business days after pickup</p>
                        </div>
                    </div>

                    @if( action !== 'exchange'){
                    <div class="refund">
                        <div class="icon">
                            <mat-icon svgIcon="onlinepay"></mat-icon>
                        </div>
                        <div class="text">
                            <label>Refund Method</label>
                            <p>Bank Transfer Selected</p>
                        </div>
                    </div>
                    }
                </div>
            </div>

            <button
                mat-flat-button
                [disabled]="returnExchangeForm.invalid"
                class="btn-primary-gradient"
                *ngIf="!isLoading"
                (click)="submit()"
            >
                {{ "returnReplaceCancel.button.continue" | translate }}
                <mat-icon svgIcon="rightarrow" iconPositionEnd></mat-icon>
            </button>
            <label class="policy"> <mat-icon [svgIcon]="'doc'"></mat-icon> View Policy</label>
        </div>
    </div>
</div>
